import React from "react";
import Navbar from "./Components/Navbar";
import Hero from "./Pages/Hero";
import About from "./Pages/About";
import WhyChooseUs from "./Pages/WhyChooseUs";
import Services from "./Pages/Services";
import Bridge from "./Pages/Bridge";
import DirectorMessage from "./Pages/DirectorMessage";
import Footer from "./Components/Footer";
import "./App.css";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <WhyChooseUs />
      <Services />
      <Bridge />
      <DirectorMessage />
      <Footer />
    </>
  );
}

export default App;